// src/config.js
const config = {
  BASE_URL: "http://54.237.212.153:5000", // Use the actual base URL of your API
  // BASE_URL: "http://localhost:5000", // Use the actual base URL of your API
};

export default config;
